import {Component, Input, OnChanges, OnDestroy, SimpleChanges} from '@angular/core';
import {UntypedFormBuilder, UntypedFormGroup} from '@angular/forms';
import {PartnerSummaryModel} from '../../../../../../partner/common/api/model/partnerSummary.model';
import {
    ReportRecipientInputFormProperty
} from '../../../../../../reporting/report/api/component/report-recipient-input-form/reportRecipientInputForm.property';
import {PartnerFindOneByIdService} from "../../../../../../partner/common/api/service/partnerFindOneById.service";
import {Subscription} from "rxjs";
import {SaleInvoiceConfigurationModel} from "../../../modules/configuration/api/entity/saleInvoiceConfiguration.model";

@Component({
    selector: 'app-sale-invoice-report-options-input-form',
    templateUrl: './sale-invoice-report-options-input-form.component.html',
    providers: [
        PartnerFindOneByIdService
    ]
})
export class SaleInvoiceReportOptionsInputFormComponent implements OnChanges, OnDestroy {

    @Input() title = 'Options';
    @Input() formGroup: UntypedFormGroup;
    @Input() partner: PartnerSummaryModel;
    @Input() officeId: number;
    @Input() userId: number;
    @Input() configuration: SaleInvoiceConfigurationModel

    commonFormGroup: UntypedFormGroup;
    recipientFormGroup: UntypedFormGroup;
    recipientPayload: ReportRecipientInputFormProperty;

    subscriptions: Subscription[] = [];

    constructor(private formBuilder: UntypedFormBuilder,
                public partnerFindOneByIdService: PartnerFindOneByIdService) {
        this.commonFormGroup = this.formBuilder.group({});
        this.recipientFormGroup = this.formBuilder.group({});
    }

    ngOnChanges(changes: SimpleChanges): void {
        if (changes['formGroup']) {
            if (this.formGroup) {
                this.formGroup.removeControl('common');
                this.formGroup.addControl('common', this.commonFormGroup);
                this.formGroup.removeControl('sendByMail');
                this.formGroup.addControl('sendByMail', this.formBuilder.control(this.configuration ? this.configuration.invoiceIncludeAddress : false));
            }
        }
        if (changes['configuration']) {
            if (this.configuration) {
                this.formGroup.patchValue({
                    sendByMail: this.configuration.invoiceIncludeAddress
                });
            }
        }
        if (changes['partner']) {
            this.recipientPayload = undefined;
            if (this.partner) {
                this.recipientPayload = new ReportRecipientInputFormProperty();
                this.partnerFindOneByIdService.loadEntity(this.partner.id)
                    .then(value => {
                        const address = value.mainAddress?.address;
                        if (address) {
                            this.recipientPayload.address = {
                                recipientName: address.recipientName?.length > 0 ? address.recipientName : this.partner.name,
                                street: address.street,
                                zipCode: address.zipCode,
                                country: address.country,
                                locality: address.locality,
                                number: address.number,
                                url: address.url,
                                navigationInstructions: address.navigationInstructions
                            };
                        }
                    });
            }
        }
    }

    ngOnDestroy() {
        this.subscriptions.forEach(subscription => subscription.unsubscribe());
    }

    sendByMailChanged() {
        this.formGroup.removeControl('recipient');
        if (this.formGroup.get('sendByMail').value === true) {
            this.formGroup.addControl('recipient', this.recipientFormGroup);
        }
    }

}
